import "./Fees_Section.css";
import { Container, Row, Col } from "react-bootstrap";
import { FaCheck, FaMoneyBillWave, FaAward, FaGlobe } from "react-icons/fa";
import CommonHeading from "../../common-component/common-heading/CommonHeading";
import { useState } from "react";
import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";

export default function Fees() {
  const fees = [
    { semester: "Semester 1", amount: "₹ 62,500" },
    { semester: "Semester 2", amount: "₹ 62,500" },
    { semester: "Semester 3", amount: "₹ 62,500" },
    { semester: "Semester 4", amount: "₹ 62,500" },
  ];

  const benefits = [
    "AI-Powered Learning Platform",
    "Career Readiness & Placement Support",
    "Internshala Student Pro Access",
    "Industry Projects & Case Studies",
    "Campus Immersion Opportunities",
  ];
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="fees_section" id="eligibility">
      <Container>
        <CommonHeading subTitle=" Investment In" title=" Your Future" />

        <Row className="align-items-start g-4">
          <Col lg={7}>
            <div className="fees_card">
              {fees.map((item, index) => (
                <div className="fee_row" key={index}>
                  <span>{item.semester}</span>
                  <span>{item.amount}</span>
                </div>
              ))}

              <div className="total_row">
                <span>Total</span>
                <h3>₹ 2,50,000</h3>
              </div>
            </div>
          </Col>

          <Col lg={5}>
            <div className="benefits_card">
              <h3>What You Get:</h3>

              <ul>
                {benefits.map((item, index) => (
                  <li key={index}>
                    <FaCheck />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="eligibility_card">
              {/* <div className="eligibility_icon">
                <FontAwesomeIcon icon={faGraduationCap} />
              </div> */}

              <div className="eligibility_content">
                <span className="eligibility_label">Eligibility</span>

                <p>
                  Graduate in any discipline, from a recognized University. Min
                  50% for regular and 45% for category students
                </p>
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mt-2 g-4">
          <Col lg={4} md={4}>
            <div className="feature_box">
              <FaMoneyBillWave className="feature_icon" />
              <div>
                <h5>No-Cost EMI Options Available</h5>
                <p>Flexible payment plans through our finance partners.</p>
              </div>
            </div>
          </Col>

          <Col lg={4} md={4}>
            <div className="feature_box">
              <FaAward className="feature_icon" />
              <div>
                <h5>Future AI Leaders' Scholarship</h5>
                <p>Apply early for fee waivers and additional perks.</p>
              </div>
            </div>
          </Col>

          <Col lg={4} md={4}>
            <div className="feature_box">
              <FaGlobe className="feature_icon" />
              <div>
                <h5>Global Immersions</h5>
                <p>
                  Students can opt for international learning experiences at an
                  additional cost.
                </p>
              </div>
            </div>
          </Col>
        </Row>

        <div className="text-center mt-4">
          <button className="apply_btn" onClick={() => setShowModal(true)}>
            Apply Now
          </button>
        </div>
        <InquiryFormModal show={showModal} onHide={() => setShowModal(false)} />
      </Container>
    </section>
  );
}
